import {
    BUSCAR_DOCUMENTOS_POR_ATRIBUTOS_LOADING,
    BUSCAR_DOCUMENTOS_POR_ATRIBUTOS_SUCCESS,
    BUSCAR_DOCUMENTOS_POR_ATRIBUTOS_FAIL  
} from '../actionTypes';
  
const initialState = {
    documentos: [], 
    isLoading: false,
    error: null
};

const documentosBuscadosPorAtributos = (state = initialState, { type, payload }) => { 
    switch (type) {
        case BUSCAR_DOCUMENTOS_POR_ATRIBUTOS_LOADING:
            return {
                ...state,
                isLoading: true,
                error: null,
            }        
        case BUSCAR_DOCUMENTOS_POR_ATRIBUTOS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                documentos: payload.documentos
            }                
        case BUSCAR_DOCUMENTOS_POR_ATRIBUTOS_FAIL:
            return {
                ...state,
                isLoading: false,
                documentos: [],
                error: payload.error,
            }                     
        default:
            return state;
    }
}

export default documentosBuscadosPorAtributos